import React from 'react';

const GlobalStyles = () => (
    <style>{`
        /* Custom scrollbar for a more subtle look */
        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
        ::-webkit-scrollbar-track {
            background: #f1f5f9; /* slate-100 */
        }
        ::-webkit-scrollbar-thumb {
            background: #b6c4d3; /* border-strong */
            border-radius: 4px;
        }
        ::-webkit-scrollbar-thumb:hover {
            background: #94a3b8; /* slate-400 */
        }

        /* Ultra-subtle chat scrollbar */
        .chat-scrollbar::-webkit-scrollbar {
            width: 4px;
        }
        .chat-scrollbar::-webkit-scrollbar-track {
            background: transparent;
        }
        .chat-scrollbar::-webkit-scrollbar-thumb {
            background: rgba(148, 163, 184, 0.3); /* Very subtle slate-400 */
            border-radius: 2px;
        }
        .chat-scrollbar::-webkit-scrollbar-thumb:hover {
            background: rgba(148, 163, 184, 0.6); /* Slightly more visible on hover */
        }
        
        /* Hide scrollbar when not scrolling (for Webkit browsers) */
        .chat-scrollbar {
            scrollbar-width: thin;
            scrollbar-color: rgba(148, 163, 184, 0.3) transparent;
        }
        .dark-scrollbar::-webkit-scrollbar-track {
            background: #1e293b; /* slate-800 */
        }
        .dark-scrollbar::-webkit-scrollbar-thumb {
            background: #475569; /* slate-600 */
        }
        .dark-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #64748b; /* slate-500 */
        }

        /* Canvas slide-in transition classes */
        .canvas-transition {
            transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;
        }
        
        .chat-compressed {
            width: 25% !important;
        }
        
        .chat-full-width {
            width: 100% !important;
        }
        
        .canvas-container {
            transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
            overflow: hidden;
        }
        
        .canvas-hidden {
            width: 0 !important;
            opacity: 0;
        }
        
        .canvas-visible {
            width: 75% !important;
            opacity: 1;
        }
        
        .canvas-compressed {
            width: 70% !important; /* 75% - 30% for reference panel = 45%, but we want some buffer */
        }
        
        /* Reference side panel */
        .reference-panel {
            transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
            overflow: hidden;
            flex-shrink: 0; /* Prevent shrinking */
            position: relative; /* Ensure proper positioning */
        }
        
        .reference-panel-hidden {
            width: 0 !important;
            opacity: 0;
        }
        
        .reference-panel-visible {
            width: 30% !important; /* Use percentage relative to parent container */
            opacity: 1;
            min-width: 300px !important; /* Ensure minimum width for readability */
            flex: 0 0 30% !important; /* Flex: grow shrink basis */
            box-sizing: border-box !important; /* Include padding/border in width calculation */
        }
        
        /* Chat font sizes — tuned up from 0.75/0.8rem so the chat column
           is legible without squinting at normal viewing distance. */
        .chat-message-text {
            font-size: 0.875rem !important; /* 14px — body-default for chat */
        }

        .chat-input-text {
            font-size: 0.9375rem !important; /* 15px — composer input */
        }
        
        /* Tabbed folder styling - ensure rounded corners */
        .canvas-folder {
            border-radius: 12px !important;
            border-top-left-radius: 12px !important;
            border-bottom-left-radius: 12px !important;
            border-bottom-right-radius: 12px !important;
        }
        
        .canvas-folder.library-active {
            border-top-right-radius: 0px !important; /* Square corner when library tab is active */
        }
        
        .canvas-folder.report-active {
            border-top-right-radius: 12px !important; /* Rounded corner when report tab is active */
        }
        
        .tab-content-area {
            border-radius: 0 0 12px 12px !important;
        }
    `}</style>
);

export default GlobalStyles;
